import keyMirror from 'keymirror';

export const manageQuizActionTypes = keyMirror({
	TOGGLE_MANAGE_QUIZ_MODAL: null,
	GET_QUIZ_AVAILABLE_SUBJECTS: null,
	GET_QUIZ_AVAILABLE_SUBJECTS_SUCCESS: null,
	GET_QUIZ_AVAILABLE_SUBJECTS_ERROR: null,
	GET_QUIZ_AVAILABLE_TOPICS: null,
	GET_QUIZ_AVAILABLE_TOPICS_SUCCESS: null,
	GET_QUIZ_AVAILABLE_TOPICS_ERROR: null,
	MANAGE_QUIZ: null,
	MANAGE_QUIZ_SUCCESS: null,
	MANAGE_QUIZ_ERROR: null,
	CLEAN_MANAGE_QUIZ_STATE: null,
});

export const MANAGE_QUIZ_FORM = 'ManageQuizForm';

export const formatTopics = (topics) =>
	topics.reduce((result, section) => {
		const sectionContent = section.body.map((item) => ({
			id: item.id,
			title: item.title,
		}));

		return result.concat(sectionContent);
	}, []);
